import { Button } from 'react-bootstrap';
import React, { useState } from 'react';
import CrearModalDev from './componentes/crearModalDev';
import TablaDevoluciones from './componentes/tablaDevoluciones';

function AdminDevoluciones() {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <div className='mx-2 mt-3'>
            <div className='d-flex flex-column flex-md-row align-items-center justify-content-between'>
                <p className='mb-2 mb-md-0 text-center'>
                    Ingresa las devoluciones que realices a tus clientes.
                </p>
                <div className='d-flex mt-2 mt-md-0'>
                    <Button variant="danger" onClick={handleShow}>
                        Ingresar Devolución
                    </Button>
                </div>
            </div>
            {/* Modal para crear devolución */}
            <CrearModalDev show={show} handleClose={handleClose} />
            {/* Table Devoluciones */}
            <div className='mt-4'>
                <TablaDevoluciones />
            </div> 
        </div>
    );
};

export default AdminDevoluciones;